import { flow, map } from 'lodash/fp';
import { stringFormatter } from 'helpers/i18n';
import prepareOptions from '../../prepareOptions';

const formatters = {
  fuelConsumption: stringFormatter(__('consumption.l')),
};

const values = [
  { max: '3' },
  { min: '3', max: '5' },
  { min: '5', max: '7' },
  { min: '7', max: '9' },
  { min: '9', max: '11' },
  { min: '11', max: '13' },
  { min: '13', max: '15' },
  { min: '15' },
];

export default flow(
  map((value) => {
    const { min, max } = value;

    let fuelConsumption = `${min}-${max}`;

    if (!max) {
      fuelConsumption = `>${min}`;
    } else if (!min) {
      fuelConsumption = `<${max}`;
    }

    return {
      label: formatters.fuelConsumption({
        fuelConsumption,
      }),
      value,
    };
  }),
  prepareOptions,
)(values);
